<template>
	<div v-editable="blok" class="flex gap-4 sm:gap-6 md:gap-8 p-4 md:px-8 md:py-6 bg-background-secondary md:bg-white rounded-2xl shadow-sm border border-border-tertiary mb-6 md:mb-10">
		<div class="flex-none w-20 h-20 md:rem:w-[150px] md:rem:h-[150px]">
			<NuxtPicture
				v-if="blok.image?.filename"
				provider="storyblok"
				height="150"
				width="150"
				:modifiers="storyblokFocusModifiers(blok.image.focus)"
				:src="blok.image.filename"
				:srcset="`${blok.image.filename}/m/80x80 80w, ${blok.image.filename}/m/150x150 150w`"
				:alt="blok.image.alt || ''"
				sizes="md:80px inf:150px"
				:img-attrs="{class:'rounded-full'}"
				loading="lazy"
			/>
		</div>

		<div class="flex-1">
			<span v-if="blok.subtitle" class="text-body-tertiary mb-2 block text-base">{{ blok.subtitle }}</span>
			<h3 v-if="blok.title" class="typo-h4 text-heading-primary mb-2">
				{{ blok.title }}
			</h3>
			<RichText class="font-primary text-xs sm:text-base text-body-primary" :data="blok.description" />

			<div v-if="blok.cta_button?.length" class="flex mt-4 gap-2">
				<StoryblokComponent v-for="item in blok.cta_button" :key="item._uid" :blok="item" class="btn-primary btn-sm" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {TipStoryblok} from '@/storyblok/types';

	interface Props {
		blok: TipStoryblok
	}
	defineProps<Props>();
</script>
